import axios, { AxiosResponse } from "axios"

/**
 * @author Pedro Antonio
 * @class UserInvitedService
 */
export default class UserInvitedService {
    /**
     * Creates an instance of UserInvitedService.
     * @param {String} apiUrl
     * @memberof UserInvitedService
     */

    constructor(apiUrl) {
        this.apiUrl = apiUrl
    }

    /**
     * @author Pedro Antonio
     * @param {string} status
     * @param {String} token
     * @returns {Object}
     * @memberof UserInvitedService
     */
    async getInvitedUsers(token, status = "enabled") {
        return axios.get(`${this.apiUrl}/users-invited`,
            {
                params: {
                    status
                },
                headers: {
                    Authorization: `Bearer ${token}`
                }
            }).then(response => response.data)
    }

    /**
     * @author Pedro Antonio  
     * @typedef {Object} invitedUserData
     * @property {string} email Correo del usuario invitado a cambiar estátus
     * @property {number} clientId Id del cliente del usuario administrador
     * @property {Date} lastInteraction Última fecha de interacción (debe mandarse del dalo del cliente)
     * @typedef {Object} returnedUser
     * @property {invitedUserData} data Datos retornados de parte del servidor
     * @property {number} statusCode Código de estado del servidor
     * @property {string} message Mensaje del servidor
     * @property {string} consecutive UUID referencia de la petición
     * @param {String} email Correo del usuario invitado a actualizar
     * @param {Date} lastInteraction Última fecha de interacción del usuario invitado
     * @param {String} token Token de autorización para hacer peticiones
     * @returns {returnedUser}
     * @memberof UserInvitedService 
     */
    async changeStatusInvited(email, token) {
        let lastInteraction = new Date()
        return axios.put(`${this.apiUrl}/change-status-invited`,
            {
                email,
                lastInteraction
            },
            {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            }).then(response => response.data)
    }

    /**
     * @author Pedro Antonio
     * @param {String} email Correo del usuario invitado a actualizar
     * @param {String} fullName Correo completo del usuario invitado a agregar
     * @param {String} token Token de autorización para hacer peticiones
     * @param {Date} lastInteraction Última fecha de interacción
     * @typedef {object} data
     * @property {object} userInvited
     * @property {number} customStatus
     * @typedef {Object} response
     * @property {string} consecutive
     * @property {number} statusCode
     * @property {data} data
     * @returns {response}
     * @memberof UserInvitedService
     */
    async createUserInvited(email, fullName, token) {
        return axios.post(`${this.apiUrl}/create-invited-user`,
            {
                email,
                fullName,
                lastInteraction: new Date()
            },
            {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            }).then(response => response.data)
    }
}